import {
  customerStatusLabel,
  formatDateTime,
  formatMoney,
  orderItems,
} from "../utils/orderHelpers";

// ---- Edit these to match your business details -----------------------------
const SHOP = {
  name: "Aquaviva Foods",
  lines: ["Manchester, United Kingdom"],
  email: "aquavivafoodsuk@gmail.com",
};
const VAT_NUMBER = ""; // e.g. "GB123456789". Leave empty if you are not VAT registered
// -----------------------------------------------------------------------------

export default function Receipt({ order }) {
  const items = orderItems(order);
  const customerName = [order.first_name, order.last_name].filter(Boolean).join(" ");
  const paidOn = order.paid_at || order.created_at;
  const cityLine = [order.city, order.postcode].filter(Boolean).join(", ");
  // orders.total already includes delivery; older orders have no delivery charge
  const deliveryFee = Number(order.delivery_fee ?? 0);
  const itemsTotal = Number(order.total) - deliveryFee;

  // The browser's print window includes "Save as PDF"; the page title becomes the file name
  function handlePrint() {
    const previousTitle = document.title;
    document.title = `${SHOP.name.replace(/\s+/g, "-")}-receipt-${order.id}`;
    window.print();
    document.title = previousTitle;
  }

  return (
    <div className="rc-wrap">
      <div className="rc-toolbar no-print">
        <button type="button" className="ui-btn ui-btn--primary" onClick={handlePrint}>
          Download receipt (PDF)
        </button>
        <span className="rc-hint">
          In the window that opens, choose "Save as PDF" as the destination.
        </span>
      </div>

      <article className="rc" aria-label={`Receipt for order ${order.id}`}>
        <header className="rc-top">
          <div>
            <div className="rc-brand">{SHOP.name}</div>
            <div className="rc-brand-meta">
              {SHOP.lines.map((line) => (
                <div key={line}>{line}</div>
              ))}
              <div>{SHOP.email}</div>
              {VAT_NUMBER && <div>VAT number: {VAT_NUMBER}</div>}
            </div>
          </div>

          <div className="rc-title">
            <h2>Receipt</h2>
            <div className="rc-brand-meta">
              <div>Order #{order.id}</div>
              <div>{formatDateTime(paidOn)}</div>
            </div>
          </div>
        </header>

        <section className="rc-meta">
          <div className="rc-block">
            <h4>Billed to</h4>
            {customerName && <p>{customerName}</p>}
            <p>{order.email}</p>
          </div>

          <div className="rc-block">
            <h4>Delivery address</h4>
            {customerName && <p>{customerName}</p>}
            {order.address && <p>{order.address}</p>}
            {cityLine && <p>{cityLine}</p>}
          </div>

          <div className="rc-block">
            <h4>Payment</h4>
            <p>Paid online (Stripe)</p>
            <p>Order status: {customerStatusLabel(order.status)}</p>
            {order.stripe_payment_intent && (
              <p>
                Reference: <span className="rc-mono">{order.stripe_payment_intent}</span>
              </p>
            )}
          </div>
        </section>

        <table className="rc-table">
          <thead>
            <tr>
              <th>Item</th>
              <th className="num">Qty</th>
              <th className="num">Unit price</th>
              <th className="num">Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, i) => (
              <tr key={i}>
                <td>{item.name}</td>
                <td className="num">{item.qty}</td>
                <td className="num">{formatMoney(item.price)}</td>
                <td className="num">{formatMoney(Number(item.price) * Number(item.qty))}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {deliveryFee > 0 && (
          <div className="rc-sub">
            <div>
              <span>Items</span>
              <span>{formatMoney(itemsTotal)}</span>
            </div>
            <div>
              <span>Delivery</span>
              <span>{formatMoney(deliveryFee)}</span>
            </div>
          </div>
        )}

        <div className="rc-total">
          <div>
            <span>Total paid</span>
            <span>{formatMoney(order.total)}</span>
          </div>
        </div>

        <footer className="rc-foot">
          Thank you for shopping with {SHOP.name}. Please keep this receipt for your records.
        </footer>
      </article>
    </div>
  );
}